import { useEffect, useState } from 'react';
import { IJob } from 'interfaces';
import { jobServices } from 'services';
import { orderBy } from 'lodash';

const useJobsAdmin = () => {
  const [jobs, setJobs] = useState<IJob[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getJobs = async (updateStatus: boolean) => {
    try {
      if (updateStatus) setLoading(true);
      const data = await jobServices.getJobs();
      const sortData = orderBy(data.logs, ['funcCode'], ['asc']);
      setJobs(sortData);
    } finally {
      if (updateStatus) setLoading(false);
    }
  };

  const runJob = async (funcCode: string) => {
    jobServices.runJob({ funcCode: funcCode });
    await getJobs(false);
  };

  useEffect(() => {
    getJobs(true);
  }, []);

  return {
    jobs,
    loading,
    getJobs,
    runJob,
  };
};

export default {
  useJobsAdmin,
};
